import initSlickWithArrowEvent from "../../components/slick-utils";

function initShopProductMediaDisplayBlockSlider(slider) {
    const slick = initSlickWithArrowEvent(
        $(slider),
        {
            arrows: true,
            dots: false,
            dotsClass: 'slick-dots',
            prevArrow: '<span class="slide-arrow prev">Prev</span>',
            nextArrow: '<span class="slide-arrow next">Next</span>',
            autoplay: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    );
}

function observeShopProductMediaDisplayBlockSlider() {
    // IntersectionObserver
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initShopProductMediaDisplayBlockSlider(entry.target);
                intersectionObserver.unobserve(entry.target);
            }
        });
    }, {rootMargin: '200px 0px'});

    document.querySelectorAll('.maier-wrapper-shop-product-media-display-block.hide-desktop .maier-media-display-block-list').forEach(slider => intersectionObserver.observe(slider));

    // MutationObserver
    const mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length >= 1) {
                for (var i = 0; i < mutation.addedNodes.length; i++) {
                    if (undefined !== mutation.addedNodes[i].localName) {
                        mutation.addedNodes[i].querySelectorAll('.maier-wrapper-shop-product-media-display-block.hide-desktop .maier-media-display-block-list').forEach(slider => initShopProductMediaDisplayBlockSlider(slider));
                    }
                }
                ;
            }
        });
    });

    mutationObserver.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });
}

function setupShopProductMediaDisplayBlock() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            observeShopProductMediaDisplayBlockSlider();
        })
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupShopProductMediaDisplayBlock);
} else {
    setupShopProductMediaDisplayBlock();
}

